enum Version {
  V1 = 'v1',
}

export const API_BASES = {
  AI: `/blocksai-api/${Version.V1}`,
} as const;
